import gql from 'graphql-tag'
export default gql `

query getJewelSiteSetting{
    getJewelSiteSetting{
      paymentModes{
        internalName
        displayName
      }
      customLabelsMap{
        domain
          typeValue
          customLabels{
            defaultName
            displayName
          }
      }
      contactNumber
      companyWhatsApp
      languages
      htmlPrint
      invoiceType
      companyProfile
      contactEmail
      companyName
      supportNumber
      disableSharedTable
      restrictBillManualDayClosure 
      integratePaymentOption
      backgroundColor
      isOfflineEnabled
      isCounterEnabled
      menuFontColor
      aggregatorMerchantId
      isAggregatorEnabled
      facebookPageId
      facebookAppId
      headerDesign
      siteOptions
      taxMethod
      noOfKot
      inventory
      isOld
      pin
      ipAddress
      cashDrawer
      macAddress
      physicalAddress
      connectedVia
        printerSize
        printers{
          uniqId
          type
          label
          value
          paperSize
          physicalAddress
          connectedVia
        }
        packagingSlipPrinters{
          uniqId
          type
          label
          value
          paperSize
        }
        billPrinters{
          uniqId
          type
          label
          value
          paperSize
          physicalAddress
          connectedVia
          serverName
          platform
        }
      printServer{
        name
        macAddress
        available
        attachedAreas
      }
      showInventory
      gallery
      isManualDayClosure
      isDayClosureEnabled
      showMyTablesOnCaptainEnabled
      closureTime
      diningSettingMenu
      gstNo
      fssai
      vatNo
      mapLink
      mapUrl
      menuDesign
      customerName
      paymentModes{
        internalName
        displayName
        paymentState
      }
      invoice
      siteMode
      menuDisplay
      premiumFeature {
        isCurrencyConversionEnabled
        isManageOutstandingEnabled
        courseManagement
        isKDSTableViewEnabled
        isCaptainIncentiveEnabled
      }
      curr
      siteId
      enabledOutstandingOnPay
      expenseCategories
      integratePaymentOption
      reasonReject
      themeDesign
      showOnlyMenu
      showMenu
      minOrderValue
      quantityReq
      # groupId
      isWalletEnabled
      qrcode{
        bucket
        region
        key
      }
      footerAddress{
        addressLineOne
      addressLineTwo
      city
      state
      zip
      country
      location{
        lat
        long
      }
      }
      latlng{
        lat
        lng
    }
    isCustomWhatsapp
    customFeilds{
      customType
      customName
      customValue
      customListValue
      menuAttached
      required
      length
    }
    availableFeilds{
      availableType
  displayName
  display
  menuAttached
  required
    }
    customCharges{
      customChargeName
      customChargeList{
        name
        rate
        chargeType
        defaultSelcted
        chargesAppliedOnInclusive
        tax

      }
    }
    isCounterEnabled
    isCustOnGroupEnabled
    customCountryCodeSel
    allowRemoveTax
    customerSegments{
      name
      discountType
      discountAmt
      # desc
    }
    customerOutstandingConfig{
        assignedType
        assignedValue
        outstandingLimitValue
        isAutoSettle
        autoSettleMode
        recurringType
        recurringValue
    }   
    disabledPoweredBy
    showBillPrintedOnCaptain
    showCustNameOnCaptain
  }
}

`




